import { useEffect, useState } from 'react';

export const useConsentChange = () => {
  const [consentVersion, setConsentVersion] = useState(0);

  useEffect(() => {
    const handleConsentChange = () => {
      setConsentVersion(prev => prev + 1);
    };
    window.addEventListener('consentChanged', handleConsentChange);
    return () => {
      window.removeEventListener('consentChanged', handleConsentChange);
    };
  }, []);

  return consentVersion;
};

export const triggerConsentChange = () => {
  window.dispatchEvent(new CustomEvent('consentChanged'));
};
